module.exports = global["application_chart_normLegend"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./norm-legend.ts");